import React from "react";

export const ArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 18h18V0H0z" opacity=".87" />
      <path
        fill="#848484"
        d="M4.747 15.023l1.328 1.327L13.5 8.925 6.075 1.5 4.747 2.828l6.098 6.097-6.098 6.098z"
      />
    </g>
  </svg>
);

export const HelpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M9.164 0c4.92 0 8.946 3.897 9.155 8.767A7.776 7.776 0 0 1 24 16.242a7.732 7.732 0 0 1-.921 3.67l-.157.278 1.044 3.776-3.776-1.044A7.73 7.73 0 0 1 16.242 24a7.776 7.776 0 0 1-7.476-5.681 9.135 9.135 0 0 1-3.958-1.091l-.302-.17-4.472 1.236 1.237-4.472A9.136 9.136 0 0 1 0 9.164C0 4.111 4.11 0 9.164 0zm9.103 10.22a9.181 9.181 0 0 1-8.046 8.047 6.367 6.367 0 0 0 6.021 4.327c1.13 0 2.227-.297 3.195-.861l.26-.16.266-.173 1.986.55-.55-1.987.173-.266a6.327 6.327 0 0 0 1.022-3.455 6.368 6.368 0 0 0-4.327-6.022zM9.164 1.406c-4.278 0-7.758 3.48-7.758 7.758 0 1.379.363 2.721 1.052 3.902l.164.27.17.264-.741 2.678 2.677-.741.264.169a7.732 7.732 0 0 0 4.172 1.216c4.278 0 7.758-3.48 7.758-7.758 0-4.278-3.48-7.758-7.758-7.758zm.703 11.297v1.406H8.461v-1.406h1.406zM9.164 4.22a2.816 2.816 0 0 1 2.813 2.812 2.82 2.82 0 0 1-.915 2.076L9.867 10.2v1.097H8.461V9.58l1.652-1.512a1.408 1.408 0 0 0-.948-2.444c-.776 0-1.407.63-1.407 1.406H6.352A2.816 2.816 0 0 1 9.164 4.22z"
    />
  </svg>
);

export const GetStartedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="#2875AA"
      fillRule="evenodd"
      d="M28.25.25H3.75a3.51 3.51 0 0 0-3.5 3.5v6.982h3.5V3.715h24.5v24.552H3.75v-7.034H.25v7.017c0 1.925 1.575 3.465 3.5 3.465h24.5c1.925 0 3.5-1.54 3.5-3.465V3.75c0-1.942-1.575-3.5-3.5-3.5zm-10.5 22.733l7-7-7-7v5.25H.25v3.5h17.5v5.25z"
    />
  </svg>
);

export const WebsiteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <path
      fill="#2875AA"
      fillRule="evenodd"
      d="M36.75 7H5.25a3.51 3.51 0 0 0-3.5 3.5v21a3.51 3.51 0 0 0 3.5 3.5h31.5a3.51 3.51 0 0 0 3.5-3.5v-21a3.51 3.51 0 0 0-3.5-3.5zm-28 8.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5zm5.25 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5zm5.25 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5zm17.5 15.75H5.25v-21h31.5v21z"
    />
  </svg>
);

export const DomainIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M17.5 42h-42V0h42z" opacity=".87" />
      <path d="M0 0h42v42H0z" />
      <path
        fill="#2875AA"
        d="M20.983 3.5C11.323 3.5 3.5 11.34 3.5 21s7.822 17.5 17.483 17.5C30.66 38.5 38.5 30.66 38.5 21S30.66 3.5 20.983 3.5zM33.11 14h-5.162a27.386 27.386 0 0 0-2.416-6.23A14.052 14.052 0 0 1 33.11 14zM21 7.07A24.652 24.652 0 0 1 24.343 14h-6.686A24.652 24.652 0 0 1 21 7.07zM7.455 24.5A14.423 14.423 0 0 1 7 21c0-1.207.175-2.38.455-3.5h5.915c-.14 1.155-.245 2.31-.245 3.5s.105 2.345.245 3.5H7.455zM8.89 28h5.162a27.386 27.386 0 0 0 2.416 6.23A13.977 13.977 0 0 1 8.89 28zm5.162-14H8.89a13.977 13.977 0 0 1 7.578-6.23A27.386 27.386 0 0 0 14.053 14zM21 34.93A24.652 24.652 0 0 1 17.657 28h6.686A24.652 24.652 0 0 1 21 34.93zm4.095-10.43h-8.19c-.158-1.155-.28-2.31-.28-3.5s.122-2.363.28-3.5h8.19c.158 1.137.28 2.31.28 3.5s-.122 2.345-.28 3.5zm.438 9.73A27.386 27.386 0 0 0 27.947 28h5.162a14.052 14.052 0 0 1-7.578 6.23zm3.097-9.73c.14-1.155.245-2.31.245-3.5s-.105-2.345-.245-3.5h5.915c.28 1.12.455 2.293.455 3.5 0 1.207-.175 2.38-.455 3.5H28.63z"
      />
    </g>
  </svg>
);

export const PaymentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <path
      fill="#2875AA"
      fillRule="evenodd"
      d="M35 7H7a3.473 3.473 0 0 0-3.482 3.5l-.018 21C3.5 33.443 5.058 35 7 35h28c1.943 0 3.5-1.557 3.5-3.5v-21C38.5 8.557 36.943 7 35 7zm0 24.5H7V21h28v10.5zM35 14H7v-3.5h28V14z"
    />
  </svg>
);

export const TelephoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      fillRule="nonzero"
      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    />
  </svg>
);

export const ContactIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="#2875AA"
      fillRule="evenodd"
      d="M12.219 0c6.56 0 11.928 5.196 12.206 11.689A10.368 10.368 0 0 1 32 21.656c0 1.738-.432 3.431-1.256 4.942l-.182.321 1.393 5.036-5.036-1.393A10.307 10.307 0 0 1 21.656 32c-4.664 0-8.74-3.143-9.968-7.575a12.18 12.18 0 0 1-5.332-1.484l-.348-.198-5.963 1.65 1.65-5.964A12.18 12.18 0 0 1 0 12.22C0 5.48 5.481 0 12.219 0zm12.137 13.627c-.648 5.614-5.115 10.081-10.729 10.729a8.49 8.49 0 0 0 8.03 5.769c1.532 0 3.022-.41 4.329-1.19l.277-.172.354-.23 2.649.733-.733-2.65.23-.353a8.436 8.436 0 0 0 1.362-4.607 8.49 8.49 0 0 0-5.769-8.029zM12.219 1.875c-5.704 0-10.344 4.64-10.344 10.344 0 1.856.493 3.662 1.429 5.248l.193.314.225.353-.988 3.57 3.57-.988.352.225a10.31 10.31 0 0 0 5.563 1.622c5.703 0 10.344-4.64 10.344-10.344S17.922 1.875 12.219 1.875zm.937 15.063v1.875h-1.875v-1.875h1.875zM12.22 5.624a3.754 3.754 0 0 1 3.75 3.75 3.76 3.76 0 0 1-1.22 2.767L13.156 13.6v1.463h-1.875v-2.288l2.202-2.016A1.877 1.877 0 0 0 12.218 7.5a1.877 1.877 0 0 0-1.874 1.875H8.469a3.754 3.754 0 0 1 3.75-3.75z"
    />
  </svg>
);

export const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <path
      fill="#2875AA"
      fillRule="evenodd"
      d="M21 10.325a3.675 3.675 0 1 1 0 7.35 3.675 3.675 0 0 1 0-7.35m0 15.75c5.198 0 10.675 2.555 10.675 3.675v1.925h-21.35V29.75c0-1.12 5.478-3.675 10.675-3.675M21 7c-3.867 0-7 3.133-7 7s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7zm0 15.75c-4.672 0-14 2.345-14 7V35h28v-5.25c0-4.655-9.328-7-14-7z"
    />
  </svg>
);

export const OrganisationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <path
      fill="#2875AA"
      fillRule="evenodd"
      d="M15.75 21a6.132 6.132 0 0 0 6.125-6.125A6.132 6.132 0 0 0 15.75 8.75a6.132 6.132 0 0 0-6.125 6.125A6.132 6.132 0 0 0 15.75 21zm0-8.75a2.621 2.621 0 0 1 2.625 2.625A2.621 2.621 0 0 1 15.75 17.5a2.621 2.621 0 0 1-2.625-2.625 2.621 2.621 0 0 1 2.625-2.625zm.088 17.5h-7.49C10.08 28.875 13.072 28 15.75 28c.193 0 .402.017.595.017.595-1.277 1.628-2.327 2.87-3.167-1.277-.228-2.485-.35-3.465-.35-4.095 0-12.25 2.047-12.25 6.125v2.625h12.25v-2.625c0-.297.035-.595.088-.875zm13.037-4.375c-3.22 0-9.625 1.767-9.625 5.25v2.625H38.5v-2.625c0-3.483-6.405-5.25-9.625-5.25zm2.117-3.185c1.33-.753 2.258-2.17 2.258-3.815A4.377 4.377 0 0 0 28.875 14a4.377 4.377 0 0 0-4.375 4.375c0 1.645.927 3.063 2.258 3.815.63.35 1.347.56 2.117.56s1.488-.21 2.117-.56z"
    />
  </svg>
);

export const ChatIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h42v42H0z" />
      <path
        fill="#2875AA"
        d="M19.25 41.282v-6.3C10.482 34.529 3.5 27.248 3.5 18.376c0-9.17 7.455-16.625 16.625-16.625S36.75 9.205 36.75 18.375c0 8.663-6.02 17.377-14.997 21.7l-2.503 1.207zm.875-36.032C12.88 5.25 7 11.13 7 18.375S12.88 31.5 20.125 31.5h2.625v4.025c6.37-4.025 10.5-10.64 10.5-17.15 0-7.245-5.88-13.125-13.125-13.125zm-1.75 20.125h3.5v3.5h-3.5v-3.5zm3.5-2.625h-3.5c0-5.688 5.25-5.25 5.25-8.75a3.51 3.51 0 0 0-3.5-3.5 3.51 3.51 0 0 0-3.5 3.5h-3.5c0-3.867 3.133-7 7-7s7 3.133 7 7c0 4.375-5.25 4.813-5.25 8.75z"
      />
    </g>
  </svg>
);

export const MessageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h42v42H0z" />
      <path
        fill="#2875AA"
        d="M7 7h28v21H9.047L7 30.047V7m0-3.5C5.075 3.5 3.518 5.075 3.518 7L3.5 38.5l7-7H35a3.51 3.51 0 0 0 3.5-3.5V7A3.51 3.51 0 0 0 35 3.5H7zM10.5 21h21v3.5h-21V21zm0-5.25h21v3.5h-21v-3.5zm0-5.25h21V14h-21v-3.5z"
      />
    </g>
  </svg>
);

export const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
  >
    <path
      fill="#2875AA"
      fillRule="evenodd"
      d="M39.2 12.162c0-1.876-1.607-3.412-3.57-3.412H7.07c-1.964 0-3.57 1.536-3.57 3.413v20.474c0 1.877 1.607 3.413 3.57 3.413h28.56c1.963 0 3.57-1.536 3.57-3.413V12.162zm-3.57 0l-14.28 8.532-14.28-8.531h28.56zm0 20.475H7.07V15.575l14.28 8.531 14.28-8.531v17.062z"
    />
  </svg>
);

export const TickIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#60C0A5"
      fillRule="evenodd"
      d="M8.6 15.6l-4.2-4.2L3 12.8l5.6 5.6 12-12L19.2 5z"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#2875AA"
        d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      />
    </g>
  </svg>
);
